export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de proveedores"])},
          "total_number_crop_field_certifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificaciones"])},
          "expired_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vencido"])},
          "days": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["En ", _interpolate(_named("days")), " días"])}
        }
      }
    }
  })
}